/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
export const SEARCH_CMS_ROSI_TAB_DATA = 'SEARCH_CMS_ROSI_TAB_DATA';
export const CMS_ROSI_DETAIL_TAB_DATA = 'CMS_ROSI_DETAIL_TAB_DATA';
export const GET_PLAN_TYPE_DATA = 'GET_PLAN_TYPE_DATA';
export const GET_COMMON_DROPDOWN_DATA = 'GET_COMMON_DROPDOWN_DATA';
export const GET_QUARTER_DATA = 'GET_QUARTER_DATA';
export const GET_AUDIT_TYPE_CMS_CD = 'GET_AUDIT_TYPE_CMS_CD';
export const GET_MANUFACTURER_DATA = 'GET_MANUFACTURER_DATA';
export const HANDLE_ERROR_MESSAGE_FOR_CMS_ROSI = 'HANDLE_ERROR_MESSAGE_FOR_CMS_ROSI';
export const GET_CMS_ROSI_BY_CRITERIA = 'GET_CMS_ROSI_BY_CRITERIA';
export const GET_UC_NDC_BY_LABELLER = 'GET_UC_NDC_BY_LABELLER';
export const GET_NDC_LIST_BY_LABELER = 'GET_NDC_LIST_BY_LABELER';
export const NDC_DETAILS = 'NDC_DETAILS';
export const UPDATE_AUDIT_CLEARED_INDEX_DATA =
  'UPDATE_AUDIT_CLEARED_INDEX_DATA';
export const GET_SEARCH_CMS_ROSI_BY_CRITERIA_LIST = 'GET_SEARCH_CMS_ROSI_BY_CRITERIA_LIST';
export const GET_SELECTED_ROW_DATA = 'GET_SELECTED_ROW_DATA';
export const HANDLE_SUCCESS_MESSAGE_FOR_CMS_ROSI = 'HANDLE_SUCCESS_MESSAGE_FOR_CMS_ROSI';
export const CMS_UPDATE_STATE = 'CMS_UPDATE_STATE';
